<div class="header">
    <h2 mat-dialog-title>{{ 'locker.access.title' | translate }}</h2>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>

<mat-dialog-content>
    <span>{{ 'locker.access.description' | translate }}</span>
    <form [formGroup]="form">
        <div class="form-row">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'locker.access.code' | translate }}</mat-label>
                <input matInput formControlName="code" maxlength="5" autocomplete="off" appUpperCase required>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-flat-button
        color="primary"
        (click)="login()"
    >
        {{ 'locker.access.confirm' | translate }}
    </button>
</mat-dialog-actions>
